/**
 * Entry point for the company home page.
 *
 * No 3D layer: this page introduces the company, and the page-turning book
 * lives on handbook.html where a visitor has chosen to look at it. Shares the
 * brand tokens and components from site.css; home.css adds the layout.
 */

import './styles/site.css';
import './styles/home.css';
import { initReveals } from './core/reveal.js';
import { initHomeEffects } from './home-effects.js';

initHomeEffects();
initReveals();
